import { render, staticRenderFns } from "./LicensePlates.vue?vue&type=template&id=158a5a36&"
import script from "./LicensePlates.vue?vue&type=script&lang=js&"
export * from "./LicensePlates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports